module.exports = __webpack_public_path__ + "static/media/Tick.5ed85120.svg";